import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RealisationHourtype } from '../classes/realisation';

@Pipe({
    name: 'hourtype',
    standalone: true,
})
export class HourtypePipe implements PipeTransform {
    transform(type: RealisationHourtype): string {
        return environment.hourtypeLabels[type] ?? '';
    }
}
